import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  CssBaseline,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Collapse,
  useMediaQuery,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  ExpandLess,
  ExpandMore,
  AccountCircle,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { Link, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import RoomServiceIcon from '@mui/icons-material/RoomService';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
const drawerWidth = 270; // Width of the drawer

const ClientSidebar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
 const [open, setOpen] = useState(false)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleSubmenuClick = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
;
const handleLogout = () => {
    localStorage.removeItem('userInfo');
    navigate("/");
  };

  const drawerBgColor = "#333"; 
  const appBarBgColor = drawerBgColor; 

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: theme.palette.primary.greyWhite, 
          color: theme.palette.primary.greyPureBlack, 
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Acceuil
          </Typography>
          <Box ml={4}>
            <Button href="/" variant="outlined" style={{ whiteSpace: 'nowrap' }} color="secondary">
              Aller sur le site
            </Button>
            </Box>
          <Box
            sx={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <Typography>Role</Typography> */}
            <IconButton
              sx={{
                color: "secondary",
                marginLeft: "auto",
              }}
              onClick={handleClick}
            >
              <AccountCircle fontSize="large" />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem 
               onClick={()=> navigate("/immo/profile")}
              >Mon profil</MenuItem>
              <MenuItem  onClick={handleLogout}>Se déconnecter</MenuItem>
            </Menu>
          </Box>

        </Toolbar>
      </AppBar>
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: theme.palette.primary.greyWhite, 
            color: theme.palette.primary.greyPureBlack,
            borderRight: "none",
          },
        }}
        anchor="left"
      >
        <List p={2}>
          <ListItem button component={Link} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Accueil" />
          </ListItem>
          <ListItem
            button
            onClick={() => navigate("/immo/dashboard")}
          >
            <ListItemIcon>
              <SpaceDashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
            {/* {openSubmenu === 'settings' ? <ExpandLess /> : <ExpandMore />} */}
          </ListItem>
          <ListItem button onClick={() => handleSubmenuClick("booking")} mt="2">
            <ListItemIcon>
              <BookmarkAddIcon />
            </ListItemIcon>
            <ListItemText primary="Reservations" />
            {openSubmenu === "list" ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openSubmenu === "booking"} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button component={Link} to="/immo/client-bookings">
                <ListItemText primary="Mes réservations" sx={{ pl: 8 }} />
              </ListItem>
              {/* <ListItem button component={Link} to="/immo/validated-bookings">
                <ListItemText primary="Réservations validées" sx={{ pl: 8 }} />
              </ListItem>
              <ListItem button component={Link} to="/immo/add-bookings">
                <ListItemText primary="Faire une reservation" sx={{ pl: 8 }} />
              </ListItem> */}
            </List>
          </Collapse>
          <ListItem
            button
            onClick={() => navigate("/immo/profile")}
          >
            <ListItemIcon>
              <ManageAccountsIcon />
            </ListItemIcon>
            <ListItemText primary="Profil" />
            {/* {openSubmenu === 'settings' ? <ExpandLess /> : <ExpandMore />} */}
          </ListItem>
        </List>
        <Divider />
      </Drawer>
      <Outlet/>

      {/* <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          p: 3,
          marginLeft: { xs: 0, sm: 0, md: drawerWidth }, // Adjust the left margin based on the sidebar
          transition: "margin 0.3s",
        }}
      > */}
        {/* <Toolbar /> */}
        {/* <Typography variant="h4" gutterBottom>
          Welcome to the Dashboard
        </Typography> */}
      {/* </Box> */}
    </Box>
  );
};

export default ClientSidebar;
